const scorePlusSampleData = [
{
    _id:"SP001",
    act:"Relationship",
    date:"2026-04-01",
    status:"Done",
    startTime:"06:00",
    duration:45,
    score:9,
    mood:8,
    energy:9,
    tags: ["A", "B", "C" ],  // Person, Position, Prop, Phase, Initiated, Result, Location
    remarks:""
},
{
    _id:"SP002",
    act:"Relationship",
    date:"2026-04-02",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP003",
    act:"Relationship",
    date:"2026-04-03",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP004",
    act:"Relationship",
    date:"2026-04-03",
    status:"Done",
    startTime:"21:00",
    duration:30,
    score:8,
    mood:8,
    energy:6,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP005",
    act:"Relationship",
    date:"2026-04-04",
    status:"Done",
    startTime:"21:00",
    duration:30,
    score:8,
    mood:8,
    energy:6,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP006",
    act:"Relationship",
    date:"2026-04-05",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP007",
    act:"Relationship",
    date:"2026-04-06",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},

{
    _id:"SP008",
    act:"Relationship",
    date:"2026-04-07",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP009",
    act:"Relationship",
    date:"2026-04-08",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P" ],
    remarks:""
},
{
    _id:"SP010",
    act:"Relationship",
    date:"2026-04-09",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP011",
    act:"Relationship",
    date:"2026-04-10",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP012",
    act:"Relationship",
    date:"2026-04-11",
    status:"Done",
    startTime:"22:45",
    duration:25,
    score:8,
    mood:8,
    energy:9,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP013",
    act:"Relationship",
    date:"2026-04-12",
    status:"Partial",
    startTime:"13:15",
    duration:30,
    score:7,
    mood:10,
    energy:0,
    tags: ["MoodOff"],
    remarks:""
},
{
    _id:"SP014",
    act:"Relationship",
    date:"2026-04-12",
    status:"Done",
    startTime:"23:00",
    duration:40,
    score:7,
    mood:0,
    energy:0,
    tags: ["SpoonP"],
    remarks:""
},
{
    _id:"SP015",
    act:"Relationship",
    date:"2026-04-13",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["Health"],
    remarks:""
},

{
    _id:"SP016",
    act:"Relationship",
    date:"2026-04-13",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["HOut"],
    remarks:""
},
{
    _id:"SP017",
    act:"Relationship",
    date:"2026-04-14",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["HOut"],
    remarks:""
},
{
    _id:"SP018",
    act:"Relationship",
    date:"2026-04-15",
    status:"Done",
    startTime:"13:30",
    duration:30,
    score:10,
    mood:8,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP019",
    act:"Relationship",
    date:"2026-04-15",
    status:"Partial",
    startTime:"20:00",
    duration:90,
    score:9,
    mood:8,
    energy:7,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP0205",
    act:"Relationship",
    date:"2026-04-15",
    status:"Done",
    startTime:"22:30",
    duration:25,
    score:8,
    mood:8,
    energy:6,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP021",
    act:"Relationship",
    date:"2026-04-16",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:6,
    tags: ["Sleep"],
    remarks:""
},
{
    _id:"SP022",
    act:"Relationship",
    date:"2026-04-17",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["NoMW"],
    remarks:""
},
{
    _id:"SP023",
    act:"Relationship",
    date:"2026-04-18",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["NoMW"],
    remarks:""
},
{
    _id:"SP024",
    act:"Relationship",
    date:"2026-04-19",
    status:"Done",
    startTime:"21:00",
    duration:20,
    score:8,
    mood:8,
    energy:7,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP025",
    act:"Relationship",
    date:"2026-04-20",
    status:"Done",
    startTime:"06:00",
    duration:45,
    score:9,
    mood:9,
    energy:9,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP026",
    act:"Relationship",
    date:"2026-04-21",
    status:"Done",
    startTime:"09:00",
    duration:30,
    score:10,
    mood:9,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP027",
    act:"Relationship",
    date:"2026-04-22",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A"],
    remarks:""
},
{
    _id:"SP028",
    act:"Relationship",
    date:"2026-04-23",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A"],
    remarks:""
},
{
    _id:"SP029",
    act:"Relationship",
    date:"2026-04-24",
    status:"Done",
    startTime:"09:00",
    duration:40,
    score:10,
    mood:9,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP030",
    act:"Relationship",
    date:"2026-04-25",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A"],
    remarks:""
},
{
    _id:"SP031",
    act:"Relationship",
    date:"2026-04-26",
    status:"Done",
    startTime:"20:00",
    duration:90,
    score:10,
    mood:10,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP032",
    act:"Relationship",
    date:"2026-04-27",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A"],
    remarks:""
},

{
    _id:"SP033",
    act:"Relationship",
    date:"2026-04-28",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:10,
    tags: ["Guest"],
    remarks:""
},
{
    _id:"SP034",
    act:"Relationship",
    date:"2026-04-29",
    status:"Done",
    startTime:"23:30",
    duration:60,
    score:10,
    mood:8,
    energy:8,
    tags: ["Stand", "FaceOff" ],
    remarks:""
},
{
    _id:"SP035",
    act:"Relationship",
    date:"2026-04-30",
    status:"Done",
    startTime:"16:00",
    duration:60,
    score:10,
    mood:10,
    energy:10,
    tags: ["CowG"],
    remarks:""
},
{
    _id:"SP036",
    act:"Relationship",
    date:"2026-05-01",
    status:"Partial",
    startTime:"21:00",
    duration:10,
    score:5,
    mood:10,
    energy:10,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP037",
    act:"Relationship",
    date:"2026-05-02",
    status:"Done",
    startTime:"22:45",
    duration:45,
    score:8,
    mood:8,
    energy:8,
    tags: ["PearlyG", "Socket"],
    remarks:""
},

{
    _id:"SP038",
    act:"Relationship",
    date:"2026-05-03",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP039",
    act:"Relationship",
    date:"2026-05-04",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP040",
    act:"Relationship",
    date:"2026-05-05",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP041",
    act:"Relationship",
    date:"2026-05-06",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP042",
    act:"Relationship",
    date:"2026-05-07",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP043",
    act:"Relationship",
    date:"2026-05-08",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP044",
    act:"Relationship",
    date:"2026-05-09",
    status:"Done",
    startTime:"14:30",
    duration:60,
    score:10,
    mood:10,
    energy:10,
    tags: ["HappyBaby"],
    remarks:""
},

{
    _id:"SP045",
    act:"Relationship",
    date:"2026-05-10",
    status:"Done",
    startTime:"01:00",
    duration:120,
    score:10,
    mood:10,
    energy:10,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP046",
    act:"Relationship",
    date:"2026-05-10",
    status:"Done",
    startTime:"23:00",
    duration:0,
    score:7,
    mood:0,
    energy:0,
    tags: ["WOT"],
    remarks:""
},
{
    _id:"SP047",
    act:"Relationship",
    date:"2026-05-11",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP048",
    act:"Relationship",
    date:"2026-05-12",
    status:"Done",
    startTime:"23:00",
    duration:10,
    score:8,
    mood:10,
    energy:10,
    tags: ["Spoon" ],
    remarks:""
},
{
    _id:"SP049",
    act:"Relationship",
    date:"2026-05-13",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP050",
    act:"Relationship",
    date:"2026-05-14",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP051",
    act:"Relationship",
    date:"2026-05-15",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},

{
    _id:"SP052",
    act:"Relationship",
    date:"2026-05-16",
    status:"Done",
    startTime:"23:00",
    duration:45,
    score:9,
    mood:9,
    energy:9,
    tags: ["Dg"],
    remarks:""
},
{
    _id:"SP053",
    act:"Relationship",
    date:"2026-05-17",
    status:"Done",
    startTime:"23:30",
    duration:30,
    score:10,
    mood:10,
    energy:8,
    tags: ["WOT"],
    remarks:""
},
{
    _id:"SP054",
    act:"Relationship",
    date:"2026-05-18",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP055",
    act:"Relationship",
    date:"2026-05-19",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP056",
    act:"Relationship",
    date:"2026-05-20",
    status:"Done",
    startTime:"22:30",
    duration:120,
    score:10,
    mood:10,
    energy:10,
    tags: ["WOT", "MOT", "Dg" ],
    remarks:""
},
{
    _id:"SP057",
    act:"Relationship",
    date:"2026-05-21",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP058",
    act:"Relationship",
    date:"2026-05-22",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},

{
    _id:"SP059",
    act:"Relationship",
    date:"2026-05-23",
    status:"Done",
    startTime:"15:00",
    duration:45,
    score:9,
    mood:9,
    energy:9,
    tags: ["FP"],
    remarks:""
},
{
    _id:"SP060",
    act:"Relationship",
    date:"2026-05-24",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP061",
    act:"Relationship",
    date:"2026-05-24",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP062",
    act:"Relationship",
    date:"2026-05-25",
    status:"Done",
    startTime:"22:00",
    duration:60,
    score:10,
    mood:10,
    energy:10,
    tags: ["Cream"],
    remarks:""
},
{
    _id:"SP063",
    act:"Relationship",
    date:"2026-05-25",
    status:"Done",
    startTime:"16:30",
    duration:45,
    score:10,
    mood:10,
    energy:10,
    tags: ["Honey"],
    remarks:""
},
{
    _id:"SP064",
    act:"Relationship",
    date:"2026-05-26",
    status:"Partial",
    startTime:"23:00",
    duration:30,
    score:8,
    mood:10,
    energy:9,
    tags: ["Choco"],
    remarks:""
},
{
    _id:"SP065",
    act:"Relationship",
    date:"2026-05-27",
    status:"Done",
    startTime:"22:45",
    duration:75,
    score:10,
    mood:10,
    energy:10,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP066",
    act:"Relationship",
    date:"2026-05-28",
    status:"Done",
    startTime:"23:00",
    duration:5,
    score:7,
    mood:10,
    energy:9,
    tags: ["PE" ],
    remarks:""
},
{
    _id:"SP067",
    act:"Relationship",
    date:"2026-05-29",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["Tussle"],
    remarks:""
},
{
    _id:"SP068",
    act:"Relationship",
    date:"2026-05-30",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["Work"],
    remarks:""
},
{
    _id:"SP069",
    act:"Relationship",
    date:"2026-05-31",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: [],
    remarks:""
},
{
    _id:"SP070",
    act:"Relationship",
    date:"2026-05-31",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["Health" ],
    remarks:""
},
{
    _id:"SP071",
    act:"Relationship",
    date:"2026-06-01",
    status:"Done",
    startTime:"06:00",
    duration:45,
    score:9,
    mood:8,
    energy:9,
    tags: ["A", "B", "C" ],  
    remarks:""
},
{
    _id:"SP072",
    act:"Relationship",
    date:"2026-06-02",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP073",
    act:"Relationship",
    date:"2026-06-03",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP074",
    act:"Relationship",
    date:"2026-06-04",
    status:"Done",
    startTime:"21:00",
    duration:30,
    score:8,
    mood:8,
    energy:6,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP075",
    act:"Relationship",
    date:"2026-06-05",
    status:"Done",
    startTime:"21:00",
    duration:30,
    score:8,
    mood:8,
    energy:6,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP131",
    act:"Relationship",
    date:"2026-06-06",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP132",
    act:"Relationship",
    date:"2026-06-07",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["P"],
    remarks:""
},

{
    _id:"SP133",
    act:"Relationship",
    date:"2026-06-08",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP134",
    act:"Relationship",
    date:"2026-06-09",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["P" ],
    remarks:""
},
{
    _id:"SP135",
    act:"Relationship",
    date:"2026-06-10",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP136",
    act:"Relationship",
    date:"2026-06-11",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:0,
    tags: ["P"],
    remarks:""
},
{
    _id:"SP137",
    act:"Relationship",
    date:"2026-06-12",
    status:"Done",
    startTime:"22:45",
    duration:90,
    score:10,
    mood:10,
    energy:10,
    tags: ["WOT", "BedR", "OilM" ],
    remarks:""
},

{
    _id:"SP138",
    act:"Relationship",
    date:"2026-06-13",
    status:"Partial",
    startTime:"13:15",
    duration:3,
    score:7,
    mood:0,
    energy:0,
    tags: ["Health"],
    remarks:""
},
{
    _id:"SP139",
    act:"Relationship",
    date:"2026-06-14",
    status:"Done",
    startTime:"23:00",
    duration:40,
    score:7,
    mood:0,
    energy:0,
    tags: ["SpoonP"],
    remarks:""
},
{
    _id:"SP140",
    act:"Relationship",
    date:"2026-06-15",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["Health"],
    remarks:""
},

{
    _id:"SP141",
    act:"Relationship",
    date:"2026-06-16",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["HOut"],
    remarks:""
},
{
    _id:"SP142",
    act:"Relationship",
    date:"2026-06-17",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["HOut"],
    remarks:""
},
{
    _id:"SP143",
    act:"Relationship",
    date:"2026-06-18",
    status:"Done",
    startTime:"13:30",
    duration:35,
    score:10,
    mood:8,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP144",
    act:"Relationship",
    date:"2026-06-19",
    status:"Partial",
    startTime:"20:00",
    duration:90,
    score:9,
    mood:8,
    energy:7,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP145",
    act:"Relationship",
    date:"2026-06-20",
    status:"Done",
    startTime:"22:30",
    duration:25,
    score:8,
    mood:8,
    energy:6,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP146",
    act:"Relationship",
    date:"2026-06-21",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:10,
    energy:8,
    tags: ["Sleep"],
    remarks:""
},
{
    _id:"SP147",
    act:"Relationship",
    date:"2026-06-22",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["NoMW"],
    remarks:""
},
{
    _id:"SP148",
    act:"Relationship",
    date:"2026-06-23",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["NoMW"],
    remarks:""
},
{
    _id:"SP149",
    act:"Relationship",
    date:"2026-06-24",
    status:"Done",
    startTime:"21:00",
    duration:20,
    score:8,
    mood:8,
    energy:7,
    tags: ["A", "B", "C" ],
    remarks:""
},

{
    _id:"SP150",
    act:"Relationship",
    date:"2026-06-25",
    status:"Done",
    startTime:"06:00",
    duration:45,
    score:9,
    mood:9,
    energy:9,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP151",
    act:"Relationship",
    date:"2026-06-26",
    status:"Done",
    startTime:"09:00",
    duration:30,
    score:10,
    mood:9,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP152",
    act:"Relationship",
    date:"2026-06-27",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A"],
    remarks:""
},
{
    _id:"SP153",
    act:"Relationship",
    date:"2026-06-28",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A"],
    remarks:""
},
{
    _id:"SP154",
    act:"Relationship",
    date:"2026-06-29",
    status:"Done",
    startTime:"09:00",
    duration:60,
    score:10,
    mood:9,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
{
    _id:"SP155",
    act:"Relationship",
    date:"2026-06-30",
    status:"Missed",
    startTime:"",
    duration:0,
    score:0,
    mood:0,
    energy:0,
    tags: ["A"],
    remarks:""
},
{
    _id:"SP156",
    act:"Relationship",
    date:"2026-06-30",
    status:"Done",
    startTime:"20:00",
    duration:90,
    score:10,
    mood:10,
    energy:8,
    tags: ["A", "B", "C" ],
    remarks:""
},
]

export default scorePlusSampleData;

